/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextArticleTIcon64Regular = forwardRef('TextArticleTIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M7.5 8a1.5 1.5 0 1 0 0 3H15v15.5a1.5 1.5 0 0 0 3 0V11h7.5a1.5 1.5 0 0 0 0-3h-18Z" }),
        React.createElement("path", { d: "M35.5 11a1.5 1.5 0 0 0 0 3h19a1.5 1.5 0 0 0 0-3h-19Z" }),
        React.createElement("path", { d: "M34 25.5a1.5 1.5 0 0 1 1.5-1.5h19a1.5 1.5 0 0 1 0 3h-19a1.5 1.5 0 0 1-1.5-1.5Z" }),
        React.createElement("path", { d: "M9.5 37a1.5 1.5 0 0 0 0 3h45a1.5 1.5 0 0 0 0-3h-45Z" }),
        React.createElement("path", { d: "M9.5 50a1.5 1.5 0 0 0 0 3h45a1.5 1.5 0 0 0 0-3h-45Z" })));
});
